import React from "react";
import { FOOTER } from "../../../layout/eng/footer";
import { SUBHEADER } from "../../../layout/eng/subheader";
import { EN_Line } from "../../../parts/eng/business/line";
import { Helmet } from "react-helmet";
export const EN_LINE = () => {
  return (
    <main id="content">
      <SUBHEADER />
      <div id="business">
        <EN_Line />
      </div>
      <FOOTER />
    </main>
  );
};
